export default __webpack_public_path__ + "static/media/list-your-property.d39db3ea.jpg";